import { render } from "./ImageItem.vue?vue&type=template&id=60f4f87a&scoped=true"
import script from "./ImageItem.vue?vue&type=script&lang=js"
export * from "./ImageItem.vue?vue&type=script&lang=js"

import "./ImageItem.vue?vue&type=style&index=0&id=60f4f87a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-60f4f87a"

export default script